<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <fieldset class="knowledge-test__question" :disabled="disabled">
    <legend>
      <span class="knowledge-test__number">{{ index + 1 }}</span
      ><span
        >{{ $t(question.text) }}
        <small v-if="index < 2">{{ $t("не влияет на балл") }}</small></span
      >
    </legend>
    <div
      class="knowledge-test__options"
      :class="{ 'knowledge-test__options--short': isShort }"
    >
      <label
        v-for="(option, optionIndex) in question.options"
        :key="optionIndex"
        class="knowledge-test__option"
        :class="{
          'knowledge-test__option--selected': modelValue === optionIndex,
        }"
      >
        <input
          type="radio"
          :name="`knowledge-question-${index}`"
          :value="optionIndex"
          :checked="modelValue === optionIndex"
          @change="$emit('update:modelValue', optionIndex)"
        />
        <span>{{ $t(option) }}</span>
      </label>
    </div>
  </fieldset>
</template>
